module.exports = __WEBPACK_EXTERNAL_MODULE__mfe_mfe_passport_remoteEntry_mjs_f26b3164__;